// 引入 wangEditor
import E from "wangeditor";
const { $, BtnMenu } = E;

// 设置默认样式
const initPStyle = "text-indent: 2em; margin:5px 0;line-height:1.75;font-weight: normal; color: #000";
export default class wLayoutMenu extends BtnMenu {
    constructor(editor) {
        // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
        const $elem = $(`<div class="w-e-menu" data-title="一键排版"><i style="font-style:normal">排</i></div>`);
        super($elem, editor);
    }

    clickHandler() {
        // 获取富文本编辑区的DOM
        let childDoms = this.editor.$textElem.elems[0].childNodes;
        let contentHtml = this.editor.txt.html();
        contentHtml = contentHtml.replace(/<br\/>/gi,"</p><p>").replace(/<br>/gi,"</p><p>").replace(/(<img[^<]*src=\"([^<]+)\"[^<]*>)/ig,'<p>$1</p>').replace(/(<iframe[^<]*src=\"([^<]+)\"[^<]*>)/ig,'<p>$1</p>');
        this.editor.txt.html(contentHtml);
        if (childDoms.length > 0) {
            childDoms.forEach(item => {
                // 富文本编辑的内容默认外层都是由p标签包容，所以直接在p标签上进行设置默认排版的样式
                if (item.nodeName == 'P') {
                    item.style.cssText = initPStyle;
                }
                if (item.childNodes.length > 0) {
                    // 遍历找到子元素中存在img标签的内容进行设置默认样式
                    item.childNodes.forEach(child => {
                        if (child.localName == 'img') {
                            // 获取原图width、height
                            let width = child.width;
                            let height = child.height;
                            let ratio = width / height;
                            let setW = 600;
                            let setH = 0;  // 等比计算
                            if (setW / setH != ratio) {
                                setH = setW / ratio;
                            }
                            // 给img标签设置行内样式
                            child.setAttribute('width', setW);
                            child.setAttribute('height', setH);
                            child.parentNode.style.cssText = "text-align: center";
                        }
                        if (child.localName == 'iframe') {
                            child.parentNode.style.cssText = "text-align: center";
                        }
                        if (child.localName == 'audio') {
                            child.style.cssText = "width: 100%";
                            child.parentNode.style.cssText = "text-indent: unset";
                        }
                    })
                }
            })
        }
    }
    // 菜单是否被激活（如果不需要，这个函数可以空着）
    tryChangeActive() { }
}


// WEBPACK FOOTER //
// ./src/wLayoutMenu.js